import React, {useContext, useState, useEffect} from "react";
import {ITypeRadar} from "../../../types";
import {UserInfoCard} from "../SidebarCardUI/UserInfoCard";
import {SidebarContentOrganisationWorker} from "./SidebarContentOrganisationWorker";
import {
  IPeople,
  IPrevPeople,
  IPhoto,
} from "../../../pages/StateInitiative/StateInitiative.type";
import {DataStateInitiativeIdsContext} from "../../../pages/StateInitiative/StateOrganisations";
import {urlApiDataCRGCI} from "../../../helper/api";
import useFetchDataCrgciWorker from "../../../hooks/useFetchDataCrgciWorker";

const getEmployeePhotoUrl = (employee: any, apiUrl?: string): string => {
  if (employee.photo?.url) {
    if (employee.photo.url.startsWith("/uploads") && apiUrl) {
      return `${apiUrl}${employee.photo.url}`;
    }
    return employee.photo.url;
  }

  return "/mocks/man-worker.png";
};

const convertEmployeeToPeople = (employee: any): IPeople => {
  return {
    id: employee.id,
    documentId: employee.documentId,
    fullName: employee.fullName,
    department: employee.department,
    role: employee.jobFunction,
    jobFunction: employee.jobFunction,
    interactionLevel: employee.interactionLevel,
    createdAt: employee.createdAt,
    updatedAt: employee.updatedAt,
    publishedAt: employee.publishedAt,
    phoneNumber: employee.phoneNumber,
    email: employee.email,
    connections: [],
    photo: employee.photo as IPhoto | null,
  };
};

interface IProps {
  data: any;
  typeRadar?: ITypeRadar;
  colorTitle?: string;
  onInitiativeClick?: (documentId: string) => void;
  activeWorker?: IPeople;
  setActiveWorker?: (worker: IPeople | undefined) => void;
  onWorkerDataChange?: (workerData: any) => void;
  setIdWorkerShowConnections?: (id: string) => void;
}

const SideBarContentStateOrganisations: React.FC<IProps> = ({
  data,
  typeRadar,
  colorTitle,
  onInitiativeClick,
  activeWorker,
  setActiveWorker,
  onWorkerDataChange,
  setIdWorkerShowConnections,
}) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showMoreInitiatives, setShowMoreInitiatives] = useState(false);
  const [showAllEmployees, setShowAllEmployees] = useState(false);
  const [prevIdWorker, setPrevIdWorker] = useState<IPrevPeople[]>([]);

  const [idWorkerShowConnections, setIdWorkerShowConnectionsLocal] =
    useState("");
  const [arrPersonsWorker, setArrPersonsWorker] = useState<IPeople[]>([]);

  const {personsConnections, arrSecondPersonsConnections} =
    useFetchDataCrgciWorker(idWorkerShowConnections);

  useEffect(() => {
    if (personsConnections?.data && arrSecondPersonsConnections) {
      if (setActiveWorker) {
        setActiveWorker(personsConnections.data);
      }
      setArrPersonsWorker(arrSecondPersonsConnections);
    }
  }, [personsConnections, arrSecondPersonsConnections, setActiveWorker]);

  const contextStateInitiative =
    useContext(DataStateInitiativeIdsContext) || {};
  const {dataIds} = contextStateInitiative;

  const organizationData = dataIds?.organizationData || data;
  const realInitiatives = organizationData?.initiatives || [];
  const initiativesCount = Array.isArray(realInitiatives)
    ? realInitiatives.length
    : 0;

  const realEmployees = organizationData?.employees || [];
  const convertedEmployees = realEmployees.map((emp: any) =>
    convertEmployeeToPeople(emp)
  );
  const employees = convertedEmployees.length > 0 ? convertedEmployees : [];

  const handleWorkerClick = (fullName: string) => {
    const worker = employees.find((w: IPeople) => w.fullName === fullName);

    if (worker) {
      // if (setActiveWorker) {
      //   console.log("Вызываем setActiveWorker с:", worker);
      //   setActiveWorker(worker);
      // }

      if (worker.documentId) {
        if (setIdWorkerShowConnections) {
          setIdWorkerShowConnections(worker.documentId);
        }
      }
    }
  };

  const handleBackToOrganisation = () => {
    if (setActiveWorker) {
      setActiveWorker(undefined);
    }
    setPrevIdWorker([]);
  };

  const handleSetIdWorkerShowConnections = (id: string) => {
    if (setIdWorkerShowConnections) {
      setIdWorkerShowConnections(id);
    }
  };

  // if (activeWorker) {
  //   return (
  //     <SidebarContentOrganisationWorker
  //       worker={activeWorker}
  //       arrPersonsWorker={arrPersonsWorker}
  //       setIdWorkerShowConnections={handleSetIdWorkerShowConnections}
  //       setPrevIdWorker={setPrevIdWorker}
  //       prevIdWorker={prevIdWorker}
  //       onBack={handleBackToOrganisation}
  //       onWorkerChange={onWorkerDataChange}
  //       onInitiativeClick={onInitiativeClick}
  //     />
  //   );
  // }

  const fullDescription = `Государственные организации, коммерческие банки, ассоциации и регуляторы играют ключевую роль в развитии цифровой экосистемы финансовых технологий. Эти участники формируют стратегические направления цифровизации государственных услуг и создания инновационных финтех-решений. Министерства и ведомства разрабатывают нормативную базу для регулирования цифровых финансовых активов и обеспечения кибербезопасности. Коммерческие банки внедряют передовые технологии для улучшения клиентского опыта и повышения эффективности операций. Совместная работа всех участников направлена на создание единой цифровой экосистемы для устойчивого развития экономики.`;

  const shortDescription =
    fullDescription.split(" ").slice(0, 40).join(" ") + "...";

  return (
    <div style={{padding: "0px"}}>
      <div
        style={{
          color: colorTitle || "#3290B7",
          fontSize: "24px",
          fontWeight: "600",
          marginBottom: "16px",
        }}
      >
        {organizationData?.name || dataIds?.trendName || "нет данных"}
      </div>

      <div style={{padding: "16px 0"}}>
        <div
          style={{
            color: "#ffffff",
            fontSize: "14px",
            lineHeight: "1.6",
            marginBottom: "16px",
          }}
        >
          {showFullDescription ? fullDescription : shortDescription}

          <button
            onClick={() => setShowFullDescription(!showFullDescription)}
            style={{
              background: "none",
              border: "none",
              color: colorTitle || "#3290B7",
              cursor: "pointer",
              fontSize: "14px",
              marginTop: "8px",
              padding: 0,
              display: "block",
              textDecoration: "underline",
            }}
          >
            {showFullDescription ? "Показать меньше" : "Показать больше"}
          </button>
        </div>

        <div style={{marginTop: "24px"}}>
          <h3
            style={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: "16px",
              fontWeight: "400",
              marginBottom: "16px",
              margin: "0 0 16px 0",
            }}
          >
            Сотрудники ({employees.length})
          </h3>

          <div style={{display: "flex", flexDirection: "column", gap: "12px"}}>
            {employees
              .slice(0, showAllEmployees ? employees.length : 4)
              .map((employee: any, index: number) => (
                <UserInfoCard
                  key={employee.documentId || `employee-${index}`}
                  imageSrc={getEmployeePhotoUrl(employee, urlApiDataCRGCI)}
                  department={employee.department || "Не указан"}
                  fullName={employee.fullName}
                  role={employee.jobFunction || "Не указана"}
                  onClick={() => handleWorkerClick(employee.fullName)}
                />
              ))}
            {employees.length > 4 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "8px",
                }}
              >
                <button
                  onClick={() => setShowAllEmployees(!showAllEmployees)}
                  style={{
                    background: "none",
                    border: "none",
                    color: colorTitle || "#3290B7",
                    cursor: "pointer",
                    fontSize: "14px",
                    padding: 0,
                    textDecoration: "underline",
                  }}
                >
                  {showAllEmployees ? "Показать меньше" : "Показать всех"}
                </button>
                <span
                  style={{
                    color: "rgba(255, 255, 255, 0.4)",
                    fontSize: "12px",
                  }}
                >
                  Показано{" "}
                  {showAllEmployees
                    ? employees.length
                    : Math.min(4, employees.length)}{" "}
                  из {employees.length}
                </span>
              </div>
            )}
          </div>
        </div>

        <div style={{marginTop: "24px"}}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "16px",
            }}
          >
            <h3
              style={{
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "16px",
                fontWeight: "400",
                margin: "0",
              }}
            >
              Инициативы организации
            </h3>
            <div
              style={{
                backgroundColor: "#3290B7",
                color: "#ffffff",
                padding: "2px 6px",
                borderRadius: "8px",
                fontSize: "12px",
                fontWeight: "500",
                minWidth: "24px",
                textAlign: "center",
              }}
            >
              {initiativesCount}
            </div>
          </div>

          <div style={{display: "flex", flexDirection: "column", gap: "8px"}}>
            {initiativesCount > 0 ? (
              <>
                {realInitiatives
                  .slice(0, showMoreInitiatives ? realInitiatives.length : 3)
                  .map((initiative: any, index: number) => (
                    <div
                      key={initiative.id || index}
                      style={{
                        backgroundColor:
                          index % 2 === 0
                            ? "rgba(42, 157, 100, 0.6)"
                            : "rgba(255, 85, 224, 0.6)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        borderRadius: "8px",
                        padding: "0 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        cursor: "pointer",
                      }}
                      onClick={() => onInitiativeClick?.(initiative.documentId)}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "50%",
                          backgroundColor:
                            index % 2 === 0
                              ? "#55FFAB"
                              : "rgba(255, 85, 224, 1)",
                        }}
                      ></div>
                      <span
                        style={{
                          color: "#ffffff",
                          fontSize: "14px",
                          flex: 1,
                        }}
                      >
                        {initiative.name}
                      </span>
                      <div
                        style={{
                          color: "rgba(255, 255, 255, 0.7)",
                          fontSize: "28px",
                        }}
                      >
                        ›
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <div
                style={{
                  padding: "24px 16px",
                  textAlign: "center",
                  color: "rgba(255, 255, 255, 0.5)",
                  fontSize: "14px",
                }}
              >
                Список пуст
              </div>
            )}
          </div>

          {initiativesCount > 3 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "12px",
              }}
            >
              <button
                onClick={() => setShowMoreInitiatives(!showMoreInitiatives)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#3290B7",
                  cursor: "pointer",
                  fontSize: "14px",
                  padding: 0,
                }}
              >
                {showMoreInitiatives ? "Показать меньше" : "Показать больше"}
              </button>
              <span
                style={{
                  color: "rgba(255, 255, 255, 0.5)",
                  fontSize: "12px",
                }}
              >
                Показано{" "}
                {showMoreInitiatives
                  ? initiativesCount
                  : Math.min(3, initiativesCount)}{" "}
                из {initiativesCount}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SideBarContentStateOrganisations;
